<style lang="stylus">
    .FormatModal-mask
        position fixed
        top 0
        left 0
        width 100vw
        height 100vh
        z-index 23333
        .FormatModal-container
            position fixed
            left 0
            right 0
            top 0
            bottom 0
            margin auto
            width 340px
            height 255px
            border-radius 5px
            background-color var(--bg-color-dialog-container)
            box-shadow $modal-shadow
            z-index 4
            .formatHeader
                position relative
                height 30px
                border-bottom 1px solid #cecece
                border-top-left-radius 5px
                border-top-right-radius 5px
                .formatHeader-title
                    float left
                    font-size 14px
                    color $modal-title-textcolor
                    margin-left 23px
                    margin-top 4px
                .formatHeader-close
                    float right
                    position relative
                    width 15px
                    height 15px
                    margin-top 8px
                    margin-right 8px
                    cursor pointer
                .formatHeader-close::before
                    content ''
                    position absolute
                    left 8px
                    width 1px
                    height 15px
                    background-color $modal-title-textcolor
                    transform rotate(42deg)
                .formatHeader-close::after
                    content ''
                    position absolute
                    left 8px
                    width 1px
                    height 15px
                    background-color $modal-title-textcolor
                    transform rotate(-42deg)
            .formatBody
                padding 8px 23px
                .formatBody-format
                    padding 10px 0
                    height 40px
                    .format-title
                        float left
                        width 50%
                    .format-checkbox
                        float left
                        position relative
                        width 16px
                        height 16px
                        border 1px solid #a9a9a9
                        border-radius 3px
                        background #fff
                        cursor pointer
                    .format-checkbox.checked
                        background var(--themeColor)
                        border-color var(--themeColor)
                    .format-checkbox.checked:after
                        content ''
                        position absolute
                        top 3px
                        left 3px
                        background transparent
                        border 2px solid #ffffff
                        border-top none
                        border-right none
                        height 6px
                        width 8px
                        transform rotate(-45deg)
                    .format-checkbox-title
                        float left
                        width 130px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        margin-left 25px
                        line-height 20px
                        font-size 12px
                        color #353535
                    .format-formatbox
                        float left
                        width 50%
                        position relative
                        .formatbox-name
                            width 120px
                            height 20px
                            font-size 12px
                            border 1px solid #ddd
                            text-align center
                            cursor pointer
                            overflow hidden
                        .formatbox-list
                            position absolute
                            box-shadow 0 0 9px #d7d7d7
                            background-color #fff
                            z-index 23333
                            width 120px
                            max-height 300px
                            overflow-y auto
                            li
                                list-style none
                                cursor pointer
                                text-align center
                                &:hover
                                    background-color #dedede
                .formatBody-btnbox
                    position absolute
                    bottom 20px
                    right 20px
                    width 180px
                    div
                        float left
                        width 80px
                        height 23px
                        text-align center
                        line-height 23px
                        border-radius 5px
                        border 1px solid #ddd
                        color #353535
                        font-size 12px
                        cursor pointer
                        user-select none
                        &:hover
                            background-color #ddd
                        &:nth-child(1)
                            margin-right 20px
</style>

<template>
    <div class="FormatModal-mask">
        <div class="FormatModal-container">
            <div class="formatHeader">
                <p class="formatHeader-title">{{ $t("title") }}</p>
                <div class="formatHeader-close" @click="clickCancel()"></div>
            </div>
            <div class="formatBody">
                <div class="formatBody-format">
                    <p class="format-title">{{ $t("format") }}:</p>
                    <div class="format-formatbox" v-click-outside="() => (showList = false)">
                        <p class="formatbox-name" v-text="Show" @click="clickFormatName()"></p>
                        <ul class="formatbox-list" v-show="showList">
                            <li v-for="(item, index) in dataList[type].FormatList" :key="index" @click="clickFormatList(index)">{{ item }}</li>
                        </ul>
                    </div>
                </div>
                <div class="formatBody-format" v-if="showParts(0)">
                    <p class="format-title">{{ $t("decimal") }}:</p>
                    <div class="format-formatbox" v-click-outside="() => (showDecimlList = false)">
                        <p id="decimalName" class="formatbox-name" @click="clickDecimalName()" v-text="dataList[type].decimal"></p>
                        <ul class="formatbox-list" @click="clickDecimalList($event)" v-show="showDecimlList">
                            <li>0</li>
                            <li>1</li>
                            <li>2</li>
                            <li>3</li>
                            <li>4</li>
                            <li>5</li>
                            <li>6</li>
                        </ul>
                    </div>
                </div>
                <div class="formatBody-format" v-if="showParts(1)">
                    <div class="format-checkbox" :class="{ checked: dataList[type].thousand }" @click="clickCheckBox()"></div>
                    <p class="format-checkbox-title">{{ $t("thousand") }}</p>
                </div>
                <div class="formatBody-format" v-if="showParts(2)">
                    <p class="format-title">{{ $t("unit") }}:</p>
                    <div class="format-formatbox" v-if="type !== 'Currency'" v-click-outside="() => (showUnitList = false)">
                        <p class="formatbox-name" @click="clickUnitName()" v-text="unitName"></p>
                        <ul class="formatbox-list" v-show="showUnitList">
                            <li v-for="(item, index) in dataList[type].unitList" :key="index" @click="clickUnitList(index)">{{ item.Name }}</li>
                        </ul>
                    </div>
                    <div class="format-formatbox" v-else v-click-outside="() => (showCurrencyList = false)">
                        <p class="formatbox-name" @click="clickCurrencyName()">{{ $t(CurrencyName) }}</p>
                        <ul class="formatbox-list" v-show="showCurrencyList">
                            <li v-for="(item, index) in dataList[type].unitList" :key="index" @click="clickCurrencyList(index)">
                                {{ $t(item.key) }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="formatBody-btnbox">
                    <div @click="selectOk()">{{ $t("confirm") }}</div>
                    <div @click="clickCancel()">{{ $t("cancel") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class FormatModal extends Vue {
        @Prop()
        type: string;
        @Prop()
        format: string;
        Show: string = "";
        str1: string = "";
        str2: string = "";
        str3: string = "";
        unitName: string = "None";
        CurrencyName: string = "None";
        CurrencyFormatState: number = 0;
        CurrencyUnitState: number = 0;
        showList: boolean = false;
        showDecimlList: boolean = false;
        showUnitList: boolean = false;
        showCurrencyList: boolean = false;
        showTypeList: number = -1;
        tempModalData: Array<object> = [];
        typeList: Array<object> = [
            {
                id: 0,
                name: "String",
            },
            {
                id: 1,
                name: "Number",
            },
            {
                id: 2,
                name: "Date",
            },
            {
                id: 3,
                name: "Duration",
            },
            {
                id: 4,
                name: "Currency",
            },
            {
                id: 5,
                name: "Boolean",
            },
            {
                id: 9,
                name: "Percentage",
            },
            {
                id: 10,
                name: "Scientific",
            },
            {
                id: 15,
                name: "Formula",
            },
        ];
        dataList: object = {
            Number: {
                FormatList: [],
                decimal: 0,
                thousand: false,
                unitList: [
                    {
                        Name: "None",
                        Flag: "",
                    },
                    {
                        Name: "Page's Unit",
                        Flag: "",
                    },
                    {
                        Name: "kilometre",
                        Flag: "km",
                    },
                    {
                        Name: "hectometre",
                        Flag: "hm",
                    },
                    {
                        Name: "dehcametre",
                        Flag: "dam",
                    },
                    {
                        Name: "metre",
                        Flag: "m",
                    },
                    {
                        Name: "decimetre",
                        Flag: "dm",
                    },
                    {
                        Name: "centimetre",
                        Flag: "cm",
                    },
                    {
                        Name: "millimetre",
                        Flag: "mm",
                    },
                    {
                        Name: "decimillimetre",
                        Flag: "dmm",
                    },
                    {
                        Name: "centimillimetre",
                        Flag: "cmm",
                    },
                    {
                        Name: "micrometre",
                        Flag: "um",
                    },
                    {
                        Name: "nautical mile",
                        Flag: "n.m",
                    },
                    {
                        Name: "mile",
                        Flag: "mi",
                    },
                    {
                        Name: "yard",
                        Flag: "yd",
                    },
                    {
                        Name: "foot",
                        Flag: "ft",
                    },
                    {
                        Name: "inch",
                        Flag: "in",
                    },
                    {
                        Name: "square kilometre",
                        Flag: "sq.km",
                    },
                    {
                        Name: "hectare",
                        Flag: "ha",
                    },
                    {
                        Name: "are",
                        Flag: "a",
                    },
                    {
                        Name: "square metre",
                        Flag: "sq.m",
                    },
                    {
                        Name: "square centimetre",
                        Flag: "sq.cm",
                    },
                    {
                        Name: "square mile",
                        Flag: "sq.mi",
                    },
                    {
                        Name: "acre",
                        Flag: "ac",
                    },
                    {
                        Name: "square yard",
                        Flag: "sq.yd",
                    },
                    {
                        Name: "square foot",
                        Flag: "sq.ft",
                    },
                    {
                        Name: "square inch",
                        Flag: "sq.in",
                    },
                    {
                        Name: "tonne",
                        Flag: "t",
                    },
                    {
                        Name: "quintal",
                        Flag: "q",
                    },
                    {
                        Name: "kilogram",
                        Flag: "kg",
                    },
                    {
                        Name: "hectogramme",
                        Flag: "hg",
                    },
                    {
                        Name: "decagramme",
                        Flag: "dag",
                    },
                    {
                        Name: "gramme",
                        Flag: "g",
                    },
                    {
                        Name: "decigramme",
                        Flag: "dg",
                    },
                    {
                        Name: "centigramme",
                        Flag: "cg",
                    },
                    {
                        Name: "milligramme",
                        Flag: "mg",
                    },
                    {
                        Name: "microgramme",
                        Flag: "ug",
                    },
                    {
                        Name: "long ton",
                        Flag: "l.t",
                    },
                    {
                        Name: "short ton",
                        Flag: "s.t",
                    },
                    {
                        Name: "hundredweight",
                        Flag: "cwt",
                    },
                    {
                        Name: "stone",
                        Flag: "stone",
                    },
                    {
                        Name: "pound",
                        Flag: "lb",
                    },
                    {
                        Name: "ounce",
                        Flag: "oz",
                    },
                    {
                        Name: "dram",
                        Flag: "dr",
                    },
                    {
                        Name: "grain",
                        Flag: "gr",
                    },
                    {
                        Name: "kilolitre",
                        Flag: "kl",
                    },
                    {
                        Name: "hectolitre",
                        Flag: "hl",
                    },
                    {
                        Name: "decalitre",
                        Flag: "dal",
                    },
                    {
                        Name: "litre",
                        Flag: "l",
                    },
                    {
                        Name: "decilitre",
                        Flag: "dl",
                    },
                    {
                        Name: "centilitre",
                        Flag: "cl",
                    },
                    {
                        Name: "millilitre",
                        Flag: "ml",
                    },
                    {
                        Name: "microlitre",
                        Flag: "ul",
                    },
                    {
                        Name: "bushel",
                        Flag: "bsh",
                    },
                    {
                        Name: "peck",
                        Flag: "pk",
                    },
                    {
                        Name: "gallon",
                        Flag: "gal",
                    },
                    {
                        Name: "quart",
                        Flag: "qt",
                    },
                    {
                        Name: "pint",
                        Flag: "p",
                    },
                    {
                        Name: "ampere",
                        Flag: "A",
                    },
                    {
                        Name: "kelvin",
                        Flag: "K",
                    },
                    {
                        Name: "mole",
                        Flag: "mol",
                    },
                    {
                        Name: "candela",
                        Flag: "cd",
                    },
                    {
                        Name: "second",
                        Flag: "s",
                    },
                    {
                        Name: "hertz",
                        Flag: "Hz",
                    },
                    {
                        Name: "pascal",
                        Flag: "Pa",
                    },
                    {
                        Name: "newton",
                        Flag: "N",
                    },
                    {
                        Name: "joule",
                        Flag: "J",
                    },
                    {
                        Name: "watt",
                        Flag: "W",
                    },
                    {
                        Name: "coulomb",
                        Flag: "C",
                    },
                    {
                        Name: "volt",
                        Flag: "V",
                    },
                    {
                        Name: "ohm",
                        Flag: "Ω",
                    },
                    {
                        Name: "farad",
                        Flag: "F",
                    },
                    {
                        Name: "henry",
                        Flag: "H",
                    },
                    {
                        Name: "centigrade",
                        Flag: "°C",
                    },
                    {
                        Name: "radian",
                        Flag: "rad",
                    },
                    {
                        Name: "steradian",
                        Flag: "sr",
                    },
                    {
                        Name: "Custom",
                        Flag: "",
                    },
                ],
            },
            Date: {
                FormatList: [
                    "yyyy-MM-dd",
                    "yyyy/M/d",
                    "M/d/yyyy",
                    "M/d/yy",
                    "d/M/yyyy",
                    "d/M/yy",
                    "M.d.yyyy",
                    "d.M.yyyy",
                    "yy-M-d",
                    "MM-dd-yy",
                    "MMMM d,yyyy",
                    "dddd,MMMM dd,yyyy",
                    "d MMMM yyyy",
                    "d-MMM-yy",
                    "MMM.d,yy",
                    "MMMM yy",
                    "MMM-yy",
                    "yyyy",
                    "MMM",
                ],
            },
            Duration: {
                FormatList: [
                    '[w] "w."',
                    '[ww] "w."',
                    '[w] "w." [d] "d."',
                    '[d] "d."',
                    '[dd] "d."',
                    '[d] "d." [h] "h."',
                    '[h] "h."',
                    '[hh] "h."',
                    '[h] "h." [mm] "m."',
                    '[mm] "m."',
                    '[mm] "m." [ss] "s."',
                    '[ss] "s."',
                ],
            },
            Currency: {
                FormatList: ["sign num", "name num", "num, name", "num"],
                decimal: 0,
                thousand: false,
                unitList: [
                    {
                        key: "currencyUnit.None",
                        Flag: "",
                        NewFlag: "",
                        Local: "None",
                    },
                    {
                        key: "currencyUnit.Australian",
                        Flag: "$A.",
                        NewFlag: "AUD",
                        Local: "Australian,Dollar",
                    },
                    {
                        key: "currencyUnit.Canada",
                        Flag: "$",
                        NewFlag: "CAD",
                        Local: "Canadian,Dollar",
                    },
                    {
                        key: "currencyUnit.Denmark",
                        Flag: "D.Kr.",
                        NewFlag: "DKK",
                        Local: "Danish,Krone",
                    },
                    {
                        key: "currencyUnit.Europe",
                        Flag: "€",
                        NewFlag: "EUR",
                        Local: "Euro",
                    },
                    {
                        key: "currencyUnit.Hong,Kong",
                        Flag: "HK$",
                        NewFlag: "HKD",
                        Local: "Hong,Kong,Dollar",
                    },
                    {
                        key: "currencyUnit.Japan",
                        Flag: "¥",
                        NewFlag: "JPY",
                        Local: "Japanese,yen",
                    },
                    {
                        key: "currencyUnit.United,Kiongdom",
                        Flag: "£",
                        NewFlag: "GBP",
                        Local: "Pound,Sterling",
                    },
                    {
                        key: "currencyUnit.Sweden",
                        Flag: "S.Kr.",
                        NewFlag: "SEK",
                        Local: "Swedish,Krona",
                    },
                    {
                        key: "currencyUnit.United,States",
                        Flag: "$",
                        NewFlag: "USD",
                        Local: "US,Dollar",
                    },
                    {
                        key: "currencyUnit.China",
                        Flag: "￥",
                        NewFlag: "CNY",
                        Local: "Yuan,Renminbi",
                    },
                    {
                        key: "currencyUnit.India",
                        Flag: "Re.",
                        NewFlag: "INR",
                        Local: "Indian,Rupee",
                    },
                    {
                        key: "currencyUnit.Korea",
                        Flag: "KRW",
                        NewFlag: "KRW",
                        Local: "South,Korean,Won",
                    },
                    {
                        key: "currencyUnit.Malaysia",
                        Flag: "M.$",
                        NewFlag: "MYR",
                        Local: "Malaysian,Ringgit",
                    },
                    {
                        key: "currencyUnit.Mexico",
                        Flag: "$",
                        NewFlag: "MXN",
                        Local: "Mexican,Peso",
                    },
                    {
                        key: "currencyUnit.South,Africa",
                        Flag: "R.",
                        NewFlag: "ZAR",
                        Local: "South,African,Rand",
                    },
                    {
                        key: "currencyUnit.Custom",
                        Flag: "",
                        NewFlag: "",
                        Local: "Custom",
                    },
                ],
            },
            Percentage: {
                decimal: 0,
            },
            Scientific: {
                FormatList: ["1.00e+14", "1.00e+14"],
                decimal: 0,
            },
            Formula: {},
        };
        showParts(type) {
            switch (type) {
                case 0: {
                    if (["Number", "Currency", "Percentage", "Scientific"].includes(this.type)) return true;
                    break;
                }
                case 1: {
                    if (["Number", "Currency"].includes(this.type)) return true;
                    break;
                }
                case 2: {
                    if (["Number", "Currency"].includes(this.type)) return true;
                    break;
                }
            }
        }
        clickCancel() {
            this.$emit("cancelChangeList");
        }
        selectOk() {
            this.$emit("changeList", this.Show); // 选择完成提交修改
        }
        clickCheckBox() {
            this.dataList[this.type].thousand = !this.dataList[this.type].thousand;
            if (this.dataList[this.type].thousand) {
                this.str1 = "#,###";
            } else {
                this.str1 = "";
            }
            this.Show = `${this.str1} ${this.str2}`;
            if (this.type === "Currency") {
                if (this.CurrencyFormatState == 0) {
                    this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].Flag;
                    this.Show = `${this.str3} ${this.Show}`;
                } else if (this.CurrencyFormatState == 1) {
                    this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].NewFlag;
                    this.Show = `${this.str3} ${this.Show}`;
                } else if (this.CurrencyFormatState == 2) {
                    this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].NewFlag;
                    this.Show = `${this.Show} ${this.str3}`;
                } else if (this.CurrencyFormatState == 3) {
                    this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].local;
                    this.Show = `${this.Show} ${this.str3}`;
                }
                return;
            }

            if (this.str3) {
                this.Show = `${this.Show} "${this.str3}"`;
            }
        }
        clickFormatName() {
            if (["Date", "Duration", "Currency", "Scientific"].includes(this.type)) {
                this.showList = true;
            }
        }
        clickDecimalName() {
            this.showDecimlList = true;
        }
        clickUnitName() {
            this.showUnitList = true;
        }
        clickCurrencyName() {
            this.showCurrencyList = true;
        }
        clickDecimalList(e) {
            this.showDecimlList = false;
            if (e.target.tagName === "LI") {
                let num = e.target.innerHTML - 0;
                this.dataList[this.type].decimal = num;
                switch (num) {
                    case 0: {
                        this.str2 = "0";
                        break;
                    }
                    case 1: {
                        this.str2 = "0.0";
                        break;
                    }
                    case 2: {
                        this.str2 = "0.00";
                        break;
                    }
                    case 3: {
                        this.str2 = "0.000";
                        break;
                    }
                    case 4: {
                        this.str2 = "0.0000";
                        break;
                    }
                    case 5: {
                        this.str2 = "0.00000";
                        break;
                    }
                    case 6: {
                        this.str2 = "0.000000";
                        break;
                    }
                }
            }
            this.Show = `${this.str1}${this.str2}`;
            if (this.str3) {
                this.Show = `${this.Show} "${this.str3}"`;
            }
            if (this.type == "Percentage") {
                this.Show += "%";
            }
            if (this.type == "Scientific") {
                this.Show = `${this.str2}${this.str1}`;
            }
        }
        clickUnitList(index) {
            this.showUnitList = false;
            this.str3 = this.dataList[this.type].unitList[index].Flag;
            this.unitName = this.dataList[this.type].unitList[index].Name;
            this.Show = `${this.str1}${this.str2}`;
            if (this.str3) {
                this.Show = `${this.Show} "${this.str3}"`;
            }
        }
        clickFormatList(index) {
            this.showList = false;
            if (this.type === "Currency") {
                this.CurrencyFormatState = index;
                if (index == 0 || index == 1) {
                    this.Show = `${this.str1}${this.str2}`;
                    if (index == 0) {
                        this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].Flag;
                    } else {
                        this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].NewFlag;
                    }
                    this.Show = `"${this.str3}" ${this.Show}`;
                } else if (index == 2 || index == 3) {
                    this.Show = `${this.str1} ${this.str2}`;
                    if (index == 2) {
                        this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].NewFlag;
                    } else {
                        this.str3 = this.dataList[this.type].unitList[this.CurrencyUnitState].Local;
                    }
                    this.Show = `${this.Show} "${this.str3}"`;
                }
            } else if (this.type === "Scientific") {
                this.str1 = index == 0 ? "E+00" : "E+0";
                this.Show = `${this.str2}${this.str1}`;
            } else {
                this.Show = this.dataList[this.type].FormatList[index];
            }
        }
        clickCurrencyList(index) {
            this.CurrencyUnitState = index;
            this.showCurrencyList = false;
            this.CurrencyName = this.dataList[this.type].unitList[index].key;
            this.Show = `${this.str1}${this.str2}`;
            if (this.CurrencyFormatState == 0) {
                this.str3 = this.dataList[this.type].unitList[index].Flag;
                this.Show = `"${this.str3}" ${this.Show}`;
            } else if (this.CurrencyFormatState == 1) {
                this.str3 = this.dataList[this.type].unitList[index].NewFlag;
                this.Show = `${this.str3} ${this.Show}`;
            } else if (this.CurrencyFormatState == 2) {
                this.str3 = this.dataList[this.type].unitList[index].NewFlag;
                this.Show = `${this.Show} ${this.str3}`;
            } else if (this.CurrencyFormatState == 3) {
                this.str3 = this.dataList[this.type].unitList[index].Local;
                this.Show = `${this.Show} ${this.str3}`;
            }
        }
        //生命周期
        mounted() {}
        created() {
            let str = this.format;
            this.Show = str;

            if (/(#,###)/g.test(str)) {
                this.dataList[this.type].thousand = true;
                this.str1 = "#,###";
            }

            let decimal = str.match(/0/g);
            this.dataList[this.type].decimal = decimal && decimal.length - 1;
            let tempstr = /\"(.*)\"/g.exec(str) && /\"(.*)\"/g.exec(str)[1];
            if (this.type == "Number" && tempstr) {
                let arr = this.dataList["Number"].unitList;
                for (let i = 0; i < arr.length; ++i) {
                    if (arr[i]["Flag"] == tempstr) {
                        this.str3 = tempstr;
                        this.unitName = arr[i]["Name"];
                    }
                }
            }
            if (this.type == "Currency" && tempstr) {
                let arr = this.dataList["Currency"].unitList;
                let flag = false;
                for (let i = 0; i < arr.length; ++i) {
                    if (arr[i]["Flag"] == tempstr) {
                        this.str3 = tempstr;
                        this.CurrencyName = arr[i]["key"];
                        flag = true;
                    }
                }
                if (!flag) {
                    for (let i = 0; i < arr.length; ++i) {
                        if (arr[i]["NewFlag"] == tempstr) {
                            this.str3 = tempstr;
                            this.CurrencyName = arr[i]["key"];
                            flag = true;
                        }
                    }
                }
                if (!flag) {
                    for (let i = 0; i < arr.length; ++i) {
                        if (arr[i]["Local"] == tempstr) {
                            this.str3 = tempstr;
                            this.CurrencyName = arr[i]["key"];
                            flag = true;
                        }
                    }
                }
            }

            // if(this.type === 'Currency'){
            //     if(tempstr == '$'){
            //         this.CurrencyName = 'United,States';
            //     }

            // }

            // let a  = this.dataList[this.type].unitList.filter((v, k) => {
            //     return tempstr == v.Flag
            // })
        }
        beforeDestroy() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "格式",
    "format": "格式",
    "decimal": "小数位",
    "thousand": "千分符",
    "unit": "单位/货币",
    "currencyUnit": {
      "None": "无",
      "Australian": "澳大利亚",
      "Canada": "加拿大",
      "Denmark": "Denmark",
      "Europe": "欧洲",
      "Hong,Kong": "香港",
      "Japan": "日本",
      "United,Kiongdom": "英国",
      "Sweden": "苏丹",
      "United,States": "美国",
      "China": "中国",
      "India": "印度",
      "Korea": "韩国",
      "Malaysia": "马来西亚",
      "Mexico": "墨西哥",
      "South,Africa": "南非",
      "Custom": "自定义"
    },
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Format",
    "format": "Format",
    "decimal": "Decimal places",
    "thousand": "Use thousand separator",
    "unit": "Unit/Currency",
    "currencyUnit": {
      "None": "None",
      "Australian": "Australian",
      "Canada": "Canada",
      "Denmark": "Danemark",
      "Europe": "Europe",
      "Hong,Kong": "Hong,Kong",
      "Japan": "Japan",
      "United,Kiongdom": "United,Kiongdom",
      "Sweden": "Sweden",
      "United,States": "United,States",
      "China": "China",
      "India": "India",
      "Korea": "Korea",
      "Malaysia": "Malaysia",
      "Mexico": "Mexico",
      "South,Africa": "South,Africa",
      "Custom": "Custom"
    },
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "de": {
    "title": "Format",
    "format": "Format",
    "decimal": "Dezimalstellen",
    "thousand": "1000-er Separator verwenden",
    "unit": "Einheit/Währung",
    "currencyUnit": {
      "None": "Keiner",
      "Australian": "Australier",
      "Canada": "Kanada",
      "Denmark": "Dänemark",
      "Europe": "Europa",
      "Hong,Kong": "Hongkong",
      "Japan": "Japan",
      "United,Kiongdom": "England",
      "Sweden": "Schweden",
      "United,States": "Amerika",
      "China": "China",
      "India": "Indien",
      "Korea": "Korea",
      "Malaysia": "Malaysia",
      "Mexico": "Mexiko",
      "South,Africa": "Südafrika",
      "Custom": "Benutzerdefiniert"
    },
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "fr": {
    "title": "Format",
    "format": "Format",
    "decimal": "Décimales",
    "thousand": "Mille signes",
    "unit": "Unité / devise",
    "currencyUnit": {
      "None": "Rien",
      "Australian": "Australien",
      "Canada": "Canada",
      "Denmark": "Danemark",
      "Europe": "L'Europe ",
      "Hong,Kong": "Hong,Kong",
      "Japan": "Japon",
      "United,Kiongdom": "Angleterre",
      "Sweden": "Suède",
      "United,States": "Amérique",
      "China": "Chine",
      "India": "Inde",
      "Korea": "Corée",
      "Malaysia": "Malaisie",
      "Mexico": "Mexique",
      "South,Africa": "Afrique du Sud",
      "Custom": "Personnaliser"
    },
    "confirm": "Ok",
    "cancel": "Annuler"
  },
  "jp": {
    "title": "書式",
    "format": "書式",
    "decimal": "小数",
    "thousand": "千分率",
    "unit": "単位",
    "currencyUnit": {
      "None": "無し",
      "Australian": "オーストラリア人",
      "Canada": "カナダ",
      "Denmark": "デンマーク",
      "Europe": "ヨーロッパ",
      "Hong,Kong": "香港",
      "Japan": "日本",
      "United,Kiongdom": "イングランド",
      "Sweden": "スウェーデン",
      "United,States": "アメリカ",
      "China": "中国",
      "India": "インド",
      "Korea": "韓国",
      "Malaysia": "マレーシア",
      "Mexico": "メキシコ",
      "South,Africa": "南アフリカ",
      "Custom": "カスタマイズ"
    },
    "confirm": "ok",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Formato",
    "format": "Formato",
    "decimal": "Decimales",
    "thousand": "Use mil separadores",
    "unit": "Unidad / Moneda",
    "currencyUnit": {
      "None": "No",
      "Australian": "Australia",
      "Canada": "Canadá",
      "Denmark": "Dinamarca",
      "Europe": "Europa",
      "Hong,Kong": "Hong Kong",
      "Japan": "Japón",
      "United,Kiongdom": "Reino Unido",
      "Sweden": "Sudán",
      "United,States": "Estados Unidos",
      "China": "porcelana",
      "India": "India",
      "Korea": "Corea",
      "Malaysia": "Malasia",
      "Mexico": "México",
      "South,Africa": "Sudáfrica",
      "Custom": "personalizar"
    },
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Formato",
    "format": "Formato",
    "decimal": "Casas Decimais",
    "thousand": "Usar separador mil",
    "unit": "Unidade/Moeda",
    "currencyUnit": {
      "None": "Nenhum",
      "Australian": "Australiano ",
      "Canada": "Canadá",
      "Denmark": "Dinamarca",
      "Europe": "Europa",
      "Hong,Kong": "Hong Kong",
      "Japan": "Japão",
      "United,Kiongdom": "Inglaterra",
      "Sweden": "Suécia",
      "United,States": "América",
      "China": "China",
      "India": "Índia",
      "Korea": "Coréia",
      "Malaysia": "Malásia",
      "Mexico": "México",
      "South,Africa": "África do Sul",
      "Custom": "personalizadas"
    },
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Formato",
    "format": "Formato",
    "decimal": "Posizioni Decimali",
    "thousand": "Usa Separatore Migliaia",
    "unit": "Unità/Valuta",
    "currencyUnit": {
      "None": "Nessuna",
      "Australian": "Australiano",
      "Canada": "Canada",
      "Denmark": "Danimarca",
      "Europe": "Europa",
      "Hong,Kong": "Hong Kong",
      "Japan": "Giappone",
      "United,Kiongdom": "Inghilterra",
      "Sweden": "Svezia",
      "United,States": "America",
      "China": "Cina",
      "India": "India",
      "Korea": "Corea",
      "Malaysia": "Malaysia",
      "Mexico": "Messico",
      "South,Africa": "Sud Africa",
      "Custom": "personalizzato"
    },
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "格式",
    "format": "格式",
    "decimal": "小數位",
    "thousand": "千分符",
    "unit": "單位/貨幣",
    "currencyUnit": {
      "None": "無",
      "Australian": "澳大利亞",
      "Canada": "加拿大",
      "Denmark": "丹麥",
      "Europe": "歐洲",
      "Hong,Kong": "香港",
      "Japan": "日本",
      "United,Kiongdom": "英國",
      "Sweden": "瑞典",
      "United,States": "美國",
      "China": "中國",
      "India": "印度",
      "Korea": "韓國",
      "Malaysia": "馬來西亞",
      "Mexico": "墨西哥",
      "South,Africa": "南非",
      "Custom": "自定義"
    },
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "형식",
    "format": "형식",
    "decimal": "소수 자리",
    "thousand": "천 분리기",
    "unit": "단위/화폐 ",
    "currencyUnit": {
      "None": "무",
      "Australian": "오스트레일리아인",
      "Canada": "캐나다",
      "Denmark": "덴마크",
      "Europe": "유럽",
      "Hong,Kong": "홍콩",
      "Japan": "일본",
      "United,Kiongdom": "영국 ",
      "Sweden": "스웨덴",
      "United,States": "미국 ",
      "China": "중국 ",
      "India": "인도",
      "Korea": "한국",
      "Malaysia": "말레이시아",
      "Mexico": "멕시코",
      "South,Africa": "남아프리카 공화국",
      "Custom": "사용자 정의"
    },
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
